export default __webpack_public_path__ + "static/media/emanuel.267abdc7.png";